//virtualSimulation
<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button type="primary" @click="addItemFn('editItem')">添加</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>根据关键字搜索实验：</span>
        <Input clearable v-model="pageData.Search" style="width:200px" />
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="sureSearch(pageData.Search)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch('')">重置</Button>
      </div>
    </div>
    <div class="list">
      <Row :gutter="16" v-if="virtual.Result.length > 0">
        <i-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="6"
          :xxl="4"
          v-for="(item, index) in virtual.Result"
          :key="index"
          class="listItem"
        >
          <Card>
            <div class="imgBox imgBox1">
              <router-link :to="{ name: 'virtual', params: { id: item.ExpID } }">
                <img :src="port + item.ExpPicUrl" />
              </router-link>
              <a class="star">
                <div v-if="item.Per.edit" @click="editItemFn(item)">
                  <Icon type="md-create" />
                </div>
                <div v-if="item.Per.delete" @click="delItemFn(item)">
                  <Icon type="ios-trash-outline" />
                </div>
              </a>
            </div>
            <div class="cardText">
              <Tooltip :content="item.ExpName">
                <div class="text-overflow">{{ item.ExpName }}</div>
              </Tooltip>
            </div>
          </Card>
        </i-col>
      </Row>
      <div v-else class="nodata">暂无数据</div>
    </div>
    <div class="page-div">
      <Page
        show-total
        :total="virtual.records"
        :current="pageData.page"
        :page-size="pageData.size"
        @on-change="changePage"
      />
    </div>
    <!-- 全局模态框 -->
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="编辑"
      :class="{ myfullscreen: true, noLeft: isCollapsed }"
      :mask-closable="false"
    >
      <Tabs v-model="activeName" type="card" class="my-tabs">
        <TabPane label="基本信息" name="name1">
          <Form ref="editItem" :model="editItem" :label-width="110" :rules="ruleValidate">
            <FormItem label="实验名称：" prop="ExpName">
              <Input clearable v-model="editItem.ExpName" style="width:50%;min-width:200px;" />
            </FormItem>
            <FormItem label="实验地址：" prop="ExpUrl">
              <div class="mr hasProgress">
                <Input clearable v-model="editItem.ExpUrl" style="width:100%;min-width:200px;" />
                <div class="Progress" v-if="showProgress">
                  <Progress :percent="percentage" hide-info></Progress>
                </div>
              </div>

              <Upload
                style="display:inline-block;margin-right:10px;"
                ref="uploadDoc"
                :name="'flies'"
                :show-upload-list="false"
                :on-success="(val) => handleSuccess(val, 'ExpUrl')"
                :format="['zip']"
                :on-format-error="handleFormatError"
                :action="port + 'api/public/Upload/UploadExpView/'"
                :before-upload="handleBeforeUpload"
              >
                <div class="icon-box">
                  <Button icon="ios-cloud-upload-outline" type="primary">上传</Button>
                </div>
              </Upload>
              <Alert type="error" style="display:inline-block;">Windows 10系统下建议使用360压缩软件压缩</Alert>
            </FormItem>
            <FormItem label="是否可以匿名访问：" prop="IsType" :label-width="150">
              <RadioGroup v-model="editItem.IsType">
                <Radio label="True">可以</Radio>
                <Radio label="False">不可以</Radio>
              </RadioGroup>
              <Alert
                type="error"
                style="display:inline-block"
              >选择“可以”，可直接匿名访问实验页面；选择“不可以”，需要通过登录平台才能进行访问</Alert>
            </FormItem>
            <FormItem label="是否对访客开放：" prop="IsOpen" :label-width="150">
              <RadioGroup v-model="editItem.IsOpen">
                <Radio label="True">可以</Radio>
                <Radio label="False">不可以</Radio>
              </RadioGroup>
              <Alert type="error" style="display:inline-block">选择“可以”，访客可访问实验页面；选择“不可以”，访客就无法访问</Alert>
            </FormItem>
            <FormItem label="实验封面：" prop="ExpPicUrl">
              <Input clearable v-model="editItem.ExpPicUrl" style="display:none" class="mr" />
              <myUpload
                v-if="showfullscreen"
                :defaultList="ExpPicUrlList"
                :isImg="'img'"
                @getUrlList="(val) => getUrlArr(val, 'ExpPicUrl')"
              ></myUpload>
            </FormItem>

            <FormItem label="实验简介：" prop="Abstract">
              <Input clearable type="textarea" v-model="editItem.Abstract" />
            </FormItem>
            <FormItem label="轮播图片：" prop="ExpShow">
              <Input clearable v-model="editItem.ExpShow" style="display:none" class="mr" />
              <myUploadList
                v-if="showfullscreen"
                :defaultList="ExpShowList"
                @getUrlListArr="getExpShowList"
              ></myUploadList>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="申报资料" name="name2">
          <Form :model="editItem" :label-width="110">
            <FormItem label="申报图片：">
              <div>
                <myUpload
                  v-if="showfullscreen"
                  :defaultList="DecImgUrlList"
                  :isImg="'img'"
                  @getUrlList="(val) => getUrlArr(val, 'DecImageUrl')"
                ></myUpload>
              </div>
            </FormItem>
            <FormItem label="申报视频：">
              <div>
                <myUpload
                  v-if="showfullscreen"
                  :defaultList="DecVideoUrlList"
                  :isImg="'Video'"
                  @getUrlList="(val) => getUrlArr(val, 'DecVideoUrl')"
                ></myUpload>
              </div>
              <div>
                <Input
                  clearable
                  type="textarea"
                  v-model="editItem.DecVideoText"
                  placeholder="在此添加申报视频简介"
                />
              </div>
            </FormItem>
            <FormItem label="引导视频：">
              <div>
                <myUpload
                  v-if="showfullscreen"
                  :defaultList="DirVideoUrlList"
                  :isImg="'Video'"
                  @getUrlList="(val) => getUrlArr(val, 'DirVideoUrl')"
                ></myUpload>
              </div>
              <div>
                <Input
                  clearable
                  type="textarea"
                  v-model="editItem.DirVideoText"
                  placeholder="在此添加引导视频简介"
                />
              </div>
            </FormItem>
            <FormItem label="申报文档：">
              <div class="mr hasProgress">
                <Input
                  clearable
                  v-model="editItem.DecDocUrl"
                  style="width:100%;min-width:200px;"
                  disabled
                />
                <div class="Progress" v-if="showProgress">
                  <Progress :percent="percentage" hide-info status="active"></Progress>
                </div>
              </div>

              <Upload
                style="display:inline-block;margin-right:10px;"
                ref="uploadDoc"
                :name="'Doc'"
                :show-upload-list="false"
                :on-success="(val) => handleSuccess(val, 'DecDocUrl')"
                :format="[
                  'txt',
                  'xlsx',
                  'xls',
                  'doc',
                  'docx',
                  'pdf',
                  'rar',
                  'zip',
                  'pptx',
                  'ppt',
                ]"
                :on-format-error="handleFormatError"
                :before-upload="handleBeforeUpload"
                :action="port + 'api/public/Upload/UploadDoc/'"
              >
                <div class="icon-box">
                  <Button icon="ios-cloud-upload-outline" type="primary">上传</Button>
                </div>
              </Upload>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="实验报告相关" name="name3">
          <Form :model="editItem" :label-width="110">
            <FormItem label="实验目的：">
              <Input clearable type="textarea" v-model="editItem.ExpMD" />
            </FormItem>
            <FormItem label="实验原理：">
              <Input clearable type="textarea" v-model="editItem.ExpYL" />
            </FormItem>
            <FormItem label="实验要求：">
              <Input clearable type="textarea" v-model="editItem.ExpRequire" />
            </FormItem>
            <FormItem label="考核标准：">
              <Input clearable type="textarea" v-model="editItem.ExpStandard" />
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="团队介绍" name="name4">
          <addItem v-bind:editItem="editItem.Team"></addItem>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button type="text" @click="showfullscreen = false">取消</Button>
        <Button type="primary" @click="sureEdit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import myUpload from "../../../components/my-upload";
import myUploadList from "../../../components/my-upload-list";
import addItem from "./addItem";
export default {
  name: "virtualSimulation",
  components: {
    myUpload: myUpload,
    myUploadList: myUploadList,
    addItem: addItem
  },
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      virtual: {
        Result: []
      },
      pageData: {
        Search: "",
        page: 1,
        size: 12
      },
      // CoursesArr: [], //所有课程
      showfullscreen: false,
      editApi: "AddExperiment",
      editItem: {
        Team: []
      },
      activeName: "name1",
      ruleValidate: {
        ExpName: [
          { required: true, message: "实验名称不能为空", trigger: "blur" }
        ],
        ExpUrl: [
          { required: true, message: "实验地址不能为空", trigger: "change" }
        ],
        IsType: [
          {
            required: true,
            message: "是否可以匿名访问不能为空",
            trigger: "change"
          }
        ],
        IsOpen: [
          {
            required: true,
            message: "是否对注册访客开放不能为空",
            trigger: "change"
          }
        ],
        ExpPicUrl: [
          { required: true, message: "实验封面不能为空", trigger: "change" }
        ],
        Abstract: [
          { required: true, message: "实验简介不能为空", trigger: "blur" }
        ],
        ExpShow: [{ required: true, message: "轮播图片不能为空" }]
      },
      ExpShowList: [],
      DecVideoUrlList: [],
      DecImgUrlList: [],
      DirVideoUrlList: [],
      urlList: [],
      showProgress: false,
      percentage: 0
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.getpageArr();
  },
  watch: {},
  methods: {
    //获取所有实验列表有分页
    async getpageArr() {
      this.virtual = await homeApi.GetExperimentArr({
        Search: this.pageData.Search ? this.pageData.Search : "",
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 12
      });
      this.loading = false;
    },
    //添加
    addItemFn(name) {
      this.activeName = "name1";
      this.editItem = {
        ExpName: "",
        ExpUrl: "",
        IsType: "",
        IsOpen: "",
        ExpPicUrl: "",
        Abstract: "",
        ExpShow: "",
        ExpMD: "",
        ExpYL: "",
        ExpRequire: "",
        ExpStandard: "",
        DecVideoUrl: "",
        DecImageUrl: "",
        DecVideoText: "",
        DirVideoUrl: "",
        DirVideoText: "",
        DecDocUrl: "",
        Team: []
      };
      this.ExpPicUrlList = [];
      this.ExpShowList = [];
      this.DecVideoUrlList = [];
      this.DecImgUrlList = [];
      this.DirVideoUrlList = [];
      this.editApi = "AddExperiment";
      this.showfullscreen = true;
    },
    //编辑
    editItemFn(row) {
      this.activeName = "name1";
      homeApi
        .GetExpById({
          ExpID: row.ExpID
        })
        .then(res => {
          console.log(res);

          this.editApi = "AmendExperiment";
          this.editItem = res;
          this.ExpPicUrlList = [{ url: res.ExpPicUrl }];
          this.DecVideoUrlList = [{ url: res.DecVideoUrl }];
          this.DecImgUrlList = [{ url: res.DecImageUrl }];
          this.DirVideoUrlList = [{ url: res.DirVideoUrl }];
          var arr = [];
          if (res.ExpShow) {
            if (res.ExpShow.length > 0) {
              arr = res.ExpShow.split(",");
              this.ExpShowList = arr.map(item => {
                return { url: item };
              });
            } else {
              this.ExpShowList = [];
            }
          } else {
            this.ExpShowList = [];
          }
          this.urlList = this.ExpShowList;
          this.editItem.IsType = this.editItem.IsType ? "True" : "False";
          this.editItem.IsOpen = this.editItem.IsOpen ? "True" : "False";

          this.showfullscreen = true;
        });
    },
    //确定添加或删除
    sureEdit(name) {
      this.$refs["editItem"].validate(valid => {
        if (valid) {
          homeApi[this.editApi](this.editItem).then(res => {
            if (res.success) {
              this.showfullscreen = false;
              this.getpageArr();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    //删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除实验",
        content: "确认删除" + row.ExpName,
        onOk: () => {
          homeApi.DelExperiment({ ExpID: row.ExpID }).then(res => {
            if (res.success) {
              this.pageData.Search = "";
              this.pageData.page = 1;
              this.getpageArr();
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    // 搜索
    sureSearch(Search) {
      this.pageData.Search = Search;
      this.pageData.page = 1;
      this.getpageArr();
    },
    //分页
    changePage(page) {
      // this.pageData.Search = "";
      this.pageData.page = page;
      this.getpageArr();
    },
    // 单张图片上传成功
    getUrlArr(val, str) {
      this.editItem[str] = val[val.length - 1].url;
      //console.log(this.editItem.DecImageUrl);
    },
    // 轮播图上传成功
    getExpShowList(val) {
      this.urlList = val;
      var str = "";
      for (var i = 0; i < this.urlList.length; i++) {
        if (i > 0) {
          str = str + "," + this.urlList[i].url;
        } else {
          str += this.urlList[i].url;
        }
      }
      this.$set(this.editItem, "ExpShow", str);
    },
    // 判断文件格式是否正确
    handleFormatError(file) {
      this.$Message.error({
        content: file.name + "文件格式不正确",
        duration: 3
      });
    },
    handleBeforeUpload(file) {
      this.showProgress = true;
      this.percentage = 0;
    },
    handleSuccess(res, str) {
      this.$set(this.editItem, str, res.msg);
      this.showProgress = false;
      this.percentage = 100;
    }
  }
};
</script>

<style></style>
